// 评价报告成品检验记录
<template>
  <div class="projectFormLess">
    <!-- 第一行-项目名称 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
        <span>项目名称</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_project_name}}</span>
      </div>
    </div>
    <!-- 第二行-项目审核内容 -->
    <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:300px">
        <img style="width:17px" src="../../assets/image/icon_shenh@2x.png" alt />
        <span>项目审核内容</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:50px;">
      <el-table
        :data="tableData1"
        style="width: 100%"
        border
        :header-cell-style="{background:'#F4F5F6'}"
      >
        <el-table-column show-overflow-tooltip align="center" prop="id" label="序号" width="50"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="content" label="检验项目"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" label="检验结果" width="220">
          <template slot-scope="scope">
            <div class="auditOpinion" style="display:flex;justify-content: center;">
              <el-radio-group v-model="scope.row.radio1" :disabled="!isSubmit">
                <el-radio :label="'0'">合格</el-radio>
                <el-radio :label="'1'">不合格</el-radio>
              </el-radio-group>
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" label="订正结果" width="220">
          <template slot-scope="scope">
            <div class="auditOpinion" style="display:flex;justify-content: center;">
              <el-radio-group v-model="scope.row.radio2" :disabled="!isSubmit">
                <el-radio :label="'0'">合格</el-radio>
                <el-radio :label="'1'">不合格</el-radio>
              </el-radio-group>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 第三行--检查情况说明及意见 -->
    <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:300px">
        <img style="width:15px" src="../../assets/image/icon_yijian@2x.png" alt />
        <span>检查情况说明及意见</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.comments"
        type="textarea"
        :autosize="{minRows: 3}"
      ></el-input>
    </div>
    <!-- 签字 -->
    <div class="writeName" style="margin-bottom:25px">
      <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
      <span style="width:100px">办公室签字</span>
      <img
        v-if="!addFormData.sign_office"
        @click="handleReceiverFlag1"
        style="width:66px;"
        src="../../assets/image/zaixianqianm@2x.png"
        alt
      />
      <img
        v-if="addFormData.sign_office"
        @click="handleReceiverFlag1(addFormData.sign_office)"
        style="width:66px;"
        :src="addFormData.sign_office"
        alt
      />
    </div>
    <!-- 日期 -->
    <div class="rightTimeRow" style="margin-bottom:30px">
      <img style="width:17px" src="../../assets/image/icon_riqi@2x.png" alt />
      <span style="color:#333;margin:0 10px">日期</span>
      <el-date-picker
        :disabled="!isSubmit"
        v-model="addFormData.date"
        type="date"
        :placeholder="isSubmit ? '选择日期' : ''"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
    </div>
    <!-- 第五行--上传附件 -->
    <div class="oneRow">
      <div class="leftLabel upLoadLabel">
        <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
        <span>上传附件</span>
      </div>
      <div class="rightInput">
        <upload-file
          :isSubmit="isSubmit"
          :imgList="this.addFormData.annex"
          :detailsImgList="detailsImgList"
          @my-upload-change="upLoadChange"
        ></upload-file>
      </div>
    </div>

    <!-- 审批备注 -->
    <div class="oneRow" style="margin-bottom:35px;margin-top:20px" v-if="addFormData.is_approve==1">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>审批备注</span>
      </div>
      <div class="rightInput">
        <el-input v-model="approval_remark"></el-input>
      </div>
    </div>

    <!-- 按钮行 -->
    <div class="btnRow">
      <el-button @click="handleSubmit('1')" v-if="addFormData.is_edit!='1'">保存草稿</el-button>
      <el-button
        style="background-color:#40A0F2"
        @click="handleSubmit('0')"
        v-if="addFormData.is_edit!='1'"
      >提交</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('-1')"
        style="background-color:#f4a029"
      >驳回</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('1')"
        style="background-color:#40A0F2"
      >审批通过</el-button>
    </div>
    <!-- 按钮行 -->
    <!-- 签名组件 -->
    <sign-dialog
      @wirtDoen="handleWriteDone1"
      :visible.sync="receiverSignFlag1"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 签名组件 -->

    <!-- 查看进度 -->
    <project-flow
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectFlowLog="this.addFormData.approval_log"
      :companyName="this.addFormData.company_name"
      :projectName="this.addFormData.project_name"
      :projectId="this.addFormData.project_id"
    ></project-flow>
    <go-finance
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectId="this.addFormData.project_id"
    ></go-finance>

    <!-- 签名详情弹窗 -->
    <el-dialog
      :visible.sync="showDetailsDia"
      width="50%"
      class="addUserDia imgDetailsDia"
      :before-close="showDetailsDiaClose"
    >
      <div class="diaContainer">
        <img :src="showDetailsSign" alt />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ProjectFlow from '../ProjectFlow'
import GoFinance from '../GoFinance'
import SignDialog from '../SignDialog'
import UploadFile from '../UploadFile'
export default {
  data() {
    return {
      showDetailsSign: '',
      showDetailsDia: false,

      S_project_name: '',
      approval_remark: '',
      isSubmit: true,
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      details_project_id: '',
      details_project_status: '',
      addFormData: {
        audit_content_json: '',
        comments: '',
        sign_office: '',
        date: '',
        annex: '',
      },
      // 文件上传组件
      detailsImgList: [],
      submitImgList: [],
      // 文件上传组件
      // 签名
      receiverSignFlag1: false,
      writeDoneImg1: '',
      // 签名
      topBarActive: '1',
      infop: '',
      value: '',
      tableData1: [
        {
          id: 1,
          content: '报告编号',
          radio1: '1',
          radio2: '1',
        },
        {
          id: 2,
          content: '报告格式',
          radio1: '1',
          radio2: '1',
        },
        {
          id: 3,
          content: '字体字号',
          radio1: '1',
          radio2: '1',
        },
        {
          id: 4,
          content: '目录及页码',
          radio1: '1',
          radio2: '1',
        },
        {
          id: 5,
          content: '报告附件',
          radio1: '1',
          radio2: '1',
        },
        {
          id: 6,
          content: '签名签章',
          radio1: '1',
          radio2: '1',
        },
        {
          id: 7,
          content: '文印质量',
          radio1: '1',
          radio2: '1',
        },
        {
          id: 8,
          content: '装订质量',
          radio1: '1',
          radio2: '1',
        },
      ],
    }
  },
  methods: {
    // *审批提交
    async handleExamine(val) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)

      param.append('approval_status', val)
      param.append('remark', this.approval_remark)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/fpinspection_approval',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      // this.$router.push('/project/index')
      this.getProjectDetails()
    },
    // *编辑提交
    async handleSubmit(val) {
      this.addFormData.audit_content_json = JSON.stringify(this.tableData1)
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)

      param.append('is_draft', val)

      param.append('audit_content_json', this.addFormData.audit_content_json)
      param.append('comments', this.addFormData.comments)
      param.append('sign_office', this.addFormData.sign_office)
      param.append('date', this.addFormData.date)

      param.append('annex', JSON.stringify(this.submitImgList))

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/fpinspection',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      // this.$router.push('/project/index')
      this.getProjectDetails()
    },
    // *获取详情
    async getProjectDetails() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/fpinspection_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      // 判断是不是首次到此流程
      if (res.datas.info.is_new != 1) {
        this.addFormData = res.datas.info
      } else {
        this.addFormData.is_edit = res.datas.info.is_edit
      }
      // 判断禁用
      if (this.addFormData.is_draft != '1' && this.addFormData.is_edit == '1') {
        this.isSubmit = false
      }
      // 项目名称
      this.S_project_name = res.datas.info.project_name
      // 判断表格
      if (this.addFormData.audit_content_json) {
        this.tableData1 = this.addFormData.audit_content_json
      }
      // 判断文件上传
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
      }
      // 判断日期
      if (
        this.addFormData.date == 'undefined' ||
        this.addFormData.date == 'null'
      ) {
        this.addFormData.date = ''
      }
      // 判断签名
      if (
        this.addFormData.sign_office == 'undefined' ||
        this.addFormData.sign_office == 'null'
      ) {
        this.addFormData.sign_office = ''
      }
      console.log('评价报告成品检验记录', this.addFormData)
    },
    // 文件上传
    upLoadChange(data) {
      console.log('文件列表', data)
      this.submitImgList = data
    },
    // 签名
    handleWriteDone1(data) {
      this.addFormData.sign_office = data
    },
    handleReceiverFlag1(url) {
      if (!this.isSubmit) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag1 = true
    },

    handleReceiverSign() {},
    // 签名
    showDetailsDiaClose() {
      this.showDetailsDia = false
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    if (this.details_project_status && this.details_project_id) {
      this.getProjectDetails()
    }
  },
  components: {
    SignDialog,
    UploadFile,
    ProjectFlow,
    GoFinance,
  },
}
</script>
<style lang="less" scoped>
@import url(../project/projectForm.less);
</style>